var map = {
	"./post1.JPG": 6085,
	"./post2.PNG": 1982,
	"./post3.JPG": 3831,
	"./post4.jpg": 4295,
	"./post5.jpg": 2362,
	"./post6.jpg": 9589,
	"./post7.JPG": 1659,
	"./post8.JPG": 8032,
	"./post9.JPG": 6349,
	"./streamlogo.png": 2416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2131;